import React from "react";
import styled from "styled-components";

const OuterContainer = styled.div`
    padding: 0 0.4em;
    width: 100%;
    display: flex;
    justify-content: center;
`;

const InnerContainer = styled.div<{ width: string }>`
    max-width: 100%;
    width: ${(props) => props.width};
`;

type CenterContainerProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    width?: string;
    className?: string;
};

export default function CenterContainer(props: CenterContainerProps) {
    return (
        <OuterContainer style={props.style} className={props.className}>
            <InnerContainer width={props.width ?? "1000px"}>{props.children}</InnerContainer>
        </OuterContainer>
    );
}
